import {deepCopyObject} from '@/utils/portuna';
import {type GetterTree} from 'vuex';
import {Filter} from '../../../../../library/filter';
import {enrolmentPhase} from '../../../../../library/modules/enrolment/enrolment';

const getters: GetterTree<EnrolmentPipelineState, RootState> = {
    phases(state: EnrolmentPipelineState): EnrolmentPipelinePhaseEntry[]
    {
        let phases = [];

        // set counts

        for (let _phase of state.phases)
        {
            let phase: EnrolmentPipelinePhaseEntry = {
                id: _phase.id,
                name: _phase.name,
                count: _phase.count,
                href: '',
                children: deepCopyObject(_phase.children),
                applications: _phase.applications,
                is_allowed_view: _phase.is_allowed_view,
            };

            phases.push(phase);

            if (phase.id === enrolmentPhase.unassigned)
            {
                continue;
            }

            phase.count = 0;

            for (let childId in phase.children)
            {
                if (phase.children.hasOwnProperty(childId))
                {
                    phase.children[childId].count = 0;
                }
            }

            let applicationFilter = state.applicationFilter && Filter.createByObject(state.applicationFilter);

            if (!phase.applications)
            {
                phase.applications = [];
            }

            if (applicationFilter)
            {
                phase.applications = applicationFilter.filter(phase.applications);
            }

            for (const application of phase.applications)
            {
                phase.count++;

                if (typeof application['child_id'] !== 'undefined' && application['child_id'])
                {
                    phase.children![application['child_id']].count++;
                }
            }
        }

        return phases;
    },

    activePhase(state, getters): EnrolmentPipelinePhaseEntry | {}
    {
        for (let phaseKey in getters.phases)
        {
            if (getters.phases.hasOwnProperty(phaseKey) && getters.phases[phaseKey].id === state.phaseId)
            {
                return getters.phases[phaseKey];
            }
        }

        return {};
    },
};

export default getters;